import React from 'react';
import { Field } from 'react-final-form';

// Utils
import { required } from 'Shared/utils/formValidations';

// Components
import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';
import FieldMetricType from './FieldMetricType';

// Styles
import './GoalTracking.scss';

type Props = {
  isEdit?: boolean;
};

const GoalTracking = ({ isEdit }: Props) => {
  const baseClassName = 'GoalTracking';

  return (
    <div className={baseClassName}>
      <FieldGroup
        label="How will you measure progress?"
        labelClassName={`${baseClassName}__label`}
        required
        labelRequired="*required"
      >
        <Field name="metricType" component={FieldMetricType} validate={required} isEdit={isEdit} />
      </FieldGroup>
    </div>
  );
};

export default GoalTracking;
